import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const CaseStudyCard = ({ data }) => {
  // console.log("this is data url ", data.url);
  const [showAll, setShowAll] = useState(false);

  const visiblecontent = showAll ? data : data.slice(0, 6);
  return (
    <>
      <div className="row">
        {visiblecontent.map((item, i) => (
          <div className="col-lg-4 col-md-6 mb-4 " key={i}>
            <div className="p-3 rounded-3 shadow-sm h-100 ">
              <img
                src={item.imageurl}
                alt=""
                className="img-casestudy w-100 mb-4"
              />
              <span className="">{item.category}</span>
              <h3 className="h3-heading my-2 truncate-1 ">
                {item.mainheading}
              </h3>
              <p className="h3-para truncate-2 ">{item.case_description}</p>
              <Link
                to={`/casestudy-details/${item.url}`}
                className="d-flex align-items-ceter  mt-4 justify-content-between  "
              >
                <button className="text-gradient  read-more ">READ MORE</button>
                <i className="flaticon-right-arrow "></i>
              </Link>
            </div>
          </div>
        ))}
      </div>
      <button
        className="theme-btn-nine d-inline casestudy-button-view"
        onClick={() => setShowAll(!showAll)}
      >
        {showAll ? "View Less" : "View More"}
      </button>
    </>
  );
};

export default CaseStudyCard;
